import { CLIENT_SORTS, DEFAULT_CLIENT_SORT, type ClientSort, type SortPreset } from '@/domain';
import { strings } from '@/shared/strings';

/** What each of the four orders is called on the two lists. */
const SORT_LABEL: Partial<Record<ClientSort, string>> = {
  '-createdAt': strings.clients.sortNewest,
  name: strings.clients.sortName,
  '-cases': strings.clients.sortMostCases,
  '-lastCase': strings.clients.sortLatestCase,
};

/**
 * The orders the Doctors and the Patients lists offer, newest record first as
 * the default. The request of 6 October 2026 (second), item 4.
 *
 * Each is ordered by the SERVER, since both lists are paged: a preset is the
 * `sort` word itself, which is also what the device remembers the choice by.
 * So there is no comparator here, and nothing to keep in step with the server's
 * idea of the order, and one list of presets serves both tables.
 */
export const CLIENT_SORT_PRESETS: readonly SortPreset<unknown>[] = CLIENT_SORTS.map((sort) => ({
  key: sort,
  label: SORT_LABEL[sort] ?? sort,
  sortParam: sort,
}));

/** The `sort` word to send for what the order control holds, newest first for anything else. */
export function clientSortOfPreset(sortParam: string | undefined): ClientSort {
  return CLIENT_SORTS.find((sort) => sort === sortParam) ?? DEFAULT_CLIENT_SORT;
}
